import React from "react";
import Modal, { ModalType } from "shared/ui/modal";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

export type OptionModalState = {
  isOpen: boolean;
  heading: string;
  description: string | JSX.Element;
};

interface Props {
  modalState: OptionModalState;
  setModalState: (state: OptionModalState) => void;
}
const OptionModal = ({ modalState, setModalState }: Props) => {
  return (
    <Modal
      isOpen={modalState.isOpen}
      setIsOpen={(isOpen: boolean) =>
        setModalState({ isOpen, heading: "", description: "" })
      }
      type={ModalType.SQUARE}
    >
      <>
        <Heading headingLevel="h2" className="gg-m-0 gg-mb-2">
          {modalState.heading}
        </Heading>

        <Text className="gg-m-0 gg-leading-6">{modalState.description}</Text>
      </>
    </Modal>
  );
};
export default OptionModal;
